import React from "react";
import { Reveal } from "../helpers";

const TECHS = [
  "React", "Next.js", "Spring Boot", "Node.js", "Java", "Python", "Flutter",
  "Android", "iOS", "AI", "Automation", "Cloud", "AWS", "Docker", "MongoDB",
  "MySQL", "PostgreSQL",
];

const Pill = ({ label }) => (
  <span className="shrink-0 mx-3 inline-flex items-center rounded-full glass border border-white/10 px-6 py-3 font-mono text-sm text-brand-sec hover:text-brand-orange hover:border-brand-orange/40 transition-colors duration-300">
    {label}
  </span>
);

export default function Technologies() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-brand-orange uppercase mb-4 text-center">/ Technologies</p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl tracking-tight text-center mb-14">
            Powered by a <span className="text-gradient-orange">modern stack</span>
          </h2>
        </Reveal>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-r from-[#050505] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-l from-[#050505] to-transparent" />
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {[...TECHS, ...TECHS].map((t, i) => (
            <Pill key={i} label={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
